/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */
import * as Types from 'src/graphql.generated'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

const defaultOptions = {} as const
export type AdvancedAdminPatientFragment = {
  __typename?: 'Patient'
  uid: string
  firstname?: string | null
  lastname?: string | null
  email?: string | null
  careTeam?: Array<{ __typename?: 'CareTeamMember'; coachID: string; isPrimary: boolean }> | null
}

export type SearchAdvancedAdminPatientsQueryVariables = Types.Exact<{
  query?: Types.InputMaybe<Types.Scalars['String']['input']>
  coachIDs?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>
  includeOnlyPrimaryPatients: Types.Scalars['Boolean']['input']
  states?: Types.InputMaybe<Array<Types.EnrollmentState> | Types.EnrollmentState>
  sources?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>
  statesOfResidence?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>
  tagIDs?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>
}>

export type SearchAdvancedAdminPatientsQuery = {
  __typename?: 'Query'
  searchPatientsV2: {
    __typename?: 'SearchPatientsResponse'
    patientCount: number
    patients: Array<{
      __typename?: 'Patient'
      uid: string
      firstname?: string | null
      lastname?: string | null
      email?: string | null
      careTeam?: Array<{ __typename?: 'CareTeamMember'; coachID: string; isPrimary: boolean }> | null
    }>
  }
}

export type GetAdvancedAdminPatientsQueryVariables = Types.Exact<{
  uids: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']
}>

export type GetAdvancedAdminPatientsQuery = {
  __typename?: 'Query'
  patients: Array<{
    __typename?: 'Patient'
    uid: string
    firstname?: string | null
    lastname?: string | null
    email?: string | null
    careTeam?: Array<{ __typename?: 'CareTeamMember'; coachID: string; isPrimary: boolean }> | null
  }>
}

export type GetAdvancedAdminSourcesQueryVariables = Types.Exact<{ [key: string]: never }>

export type GetAdvancedAdminSourcesQuery = {
  __typename?: 'Query'
  sources: Array<{ __typename?: 'Source'; name: string }>
}

export const AdvancedAdminPatientFragmentDoc = gql`
  fragment AdvancedAdminPatient on Patient {
    uid
    firstname
    lastname
    email
    careTeam {
      coachID
      isPrimary
    }
  }
`
export const SearchAdvancedAdminPatientsDocument = gql`
  query searchAdvancedAdminPatients(
    $query: String
    $coachIDs: [ID!]
    $includeOnlyPrimaryPatients: Boolean!
    $states: [EnrollmentState!]
    $sources: [String!]
    $statesOfResidence: [String!]
    $tagIDs: [ID!]
  ) {
    searchPatientsV2(
      query: $query
      coachIDs: $coachIDs
      includeOnlyPrimaryPatients: $includeOnlyPrimaryPatients
      states: $states
      sources: $sources
      statesOfResidence: $statesOfResidence
      tagIDs: $tagIDs
      page: 0
      pageSize: 499
      sortBy: LAST_NAME
      sortOrder: ASC
    ) {
      patients {
        ...AdvancedAdminPatient
      }
      patientCount
    }
  }
  ${AdvancedAdminPatientFragmentDoc}
`

/**
 * __useSearchAdvancedAdminPatientsQuery__
 *
 * To run a query within a React component, call `useSearchAdvancedAdminPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAdvancedAdminPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAdvancedAdminPatientsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      coachIDs: // value for 'coachIDs'
 *      includeOnlyPrimaryPatients: // value for 'includeOnlyPrimaryPatients'
 *      states: // value for 'states'
 *      sources: // value for 'sources'
 *      statesOfResidence: // value for 'statesOfResidence'
 *      tagIDs: // value for 'tagIDs'
 *   },
 * });
 */
export function useSearchAdvancedAdminPatientsQuery(
  baseOptions: Apollo.QueryHookOptions<SearchAdvancedAdminPatientsQuery, SearchAdvancedAdminPatientsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SearchAdvancedAdminPatientsQuery, SearchAdvancedAdminPatientsQueryVariables>(
    SearchAdvancedAdminPatientsDocument,
    options
  )
}
export function useSearchAdvancedAdminPatientsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<SearchAdvancedAdminPatientsQuery, SearchAdvancedAdminPatientsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<SearchAdvancedAdminPatientsQuery, SearchAdvancedAdminPatientsQueryVariables>(
    SearchAdvancedAdminPatientsDocument,
    options
  )
}
export type SearchAdvancedAdminPatientsQueryHookResult = ReturnType<typeof useSearchAdvancedAdminPatientsQuery>
export type SearchAdvancedAdminPatientsLazyQueryHookResult = ReturnType<typeof useSearchAdvancedAdminPatientsLazyQuery>
export type SearchAdvancedAdminPatientsQueryResult = Apollo.QueryResult<
  SearchAdvancedAdminPatientsQuery,
  SearchAdvancedAdminPatientsQueryVariables
>
export const GetAdvancedAdminPatientsDocument = gql`
  query getAdvancedAdminPatients($uids: [ID!]!) {
    patients(uids: $uids) {
      ...AdvancedAdminPatient
    }
  }
  ${AdvancedAdminPatientFragmentDoc}
`

/**
 * __useGetAdvancedAdminPatientsQuery__
 *
 * To run a query within a React component, call `useGetAdvancedAdminPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvancedAdminPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvancedAdminPatientsQuery({
 *   variables: {
 *      uids: // value for 'uids'
 *   },
 * });
 */
export function useGetAdvancedAdminPatientsQuery(
  baseOptions: Apollo.QueryHookOptions<GetAdvancedAdminPatientsQuery, GetAdvancedAdminPatientsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdvancedAdminPatientsQuery, GetAdvancedAdminPatientsQueryVariables>(
    GetAdvancedAdminPatientsDocument,
    options
  )
}
export function useGetAdvancedAdminPatientsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAdvancedAdminPatientsQuery, GetAdvancedAdminPatientsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdvancedAdminPatientsQuery, GetAdvancedAdminPatientsQueryVariables>(
    GetAdvancedAdminPatientsDocument,
    options
  )
}
export type GetAdvancedAdminPatientsQueryHookResult = ReturnType<typeof useGetAdvancedAdminPatientsQuery>
export type GetAdvancedAdminPatientsLazyQueryHookResult = ReturnType<typeof useGetAdvancedAdminPatientsLazyQuery>
export type GetAdvancedAdminPatientsQueryResult = Apollo.QueryResult<
  GetAdvancedAdminPatientsQuery,
  GetAdvancedAdminPatientsQueryVariables
>
export const GetAdvancedAdminSourcesDocument = gql`
  query getAdvancedAdminSources {
    sources {
      name
    }
  }
`

/**
 * __useGetAdvancedAdminSourcesQuery__
 *
 * To run a query within a React component, call `useGetAdvancedAdminSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvancedAdminSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvancedAdminSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdvancedAdminSourcesQuery(
  baseOptions?: Apollo.QueryHookOptions<GetAdvancedAdminSourcesQuery, GetAdvancedAdminSourcesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdvancedAdminSourcesQuery, GetAdvancedAdminSourcesQueryVariables>(
    GetAdvancedAdminSourcesDocument,
    options
  )
}
export function useGetAdvancedAdminSourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetAdvancedAdminSourcesQuery, GetAdvancedAdminSourcesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdvancedAdminSourcesQuery, GetAdvancedAdminSourcesQueryVariables>(
    GetAdvancedAdminSourcesDocument,
    options
  )
}
export type GetAdvancedAdminSourcesQueryHookResult = ReturnType<typeof useGetAdvancedAdminSourcesQuery>
export type GetAdvancedAdminSourcesLazyQueryHookResult = ReturnType<typeof useGetAdvancedAdminSourcesLazyQuery>
export type GetAdvancedAdminSourcesQueryResult = Apollo.QueryResult<
  GetAdvancedAdminSourcesQuery,
  GetAdvancedAdminSourcesQueryVariables
>
